import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/app/layouts/admin.vue").then(m => m.default || m)),
  block: defineAsyncComponent(() => import("/app/layouts/block.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m))
}